// The task item: TipTap's, with its checkbox named without a second copy of
// the item's text in the page.
//
// TipTap's node view names the checkbox twice: `aria-label` on the input, and
// a visually hidden span in the label holding the same words ("Task item
// checkbox for <the item's text>"). That span is text in the page, so find in
// page (the desktop app's ⌘F) counted every task twice while one showed. The
// span is taken out; the input keeps its `aria-label`, which is what a screen
// reader reads anyway. Schema and markdown are TipTap's.
//
// Its text after a code block is read as a paragraph, as in list-item.ts (here
// TipTap reads the blocks after the first line with `parseChildren`, which left
// such text bare in the item).
import type { MarkdownToken } from "@tiptap/core";
import { TaskItem } from "@tiptap/extension-task-item";

const asParagraph = (t: MarkdownToken): MarkdownToken =>
  t.type === "text" && (t.tokens?.length ?? 0) > 0
    ? { ...t, type: "paragraph" }
    : t;

// TipTap's reader is a plain function (no `this`), called as is.
const readItem = TaskItem.config.parseMarkdown;

export const TrameriaTaskItem = TaskItem.extend({
  parseMarkdown(token, helpers) {
    if (!readItem) return [];
    const nested = token.nestedTokens as MarkdownToken[] | undefined;
    if (!nested?.length) return readItem(token, helpers);
    return readItem(
      { ...token, nestedTokens: nested.map(asParagraph) },
      helpers,
    );
  },
  addNodeView() {
    const base = this.parent?.();
    if (!base) return null;
    return (props) => {
      const view = base(props);
      if (view.dom instanceof HTMLElement)
        view.dom.querySelector(":scope > label > span")?.remove();
      return view;
    };
  },
}).configure({ nested: true });
